const drawer = document.getElementById('quickViewDrawer');
  const drawerOverlay = document.getElementById('drawerOverlay');
  const drawerCloseBtn = document.getElementById('drawerCloseBtn');
  const altContainer = document.getElementById('altContainer');
  const spinner = document.getElementById('product-quick-view-spinner');
  const fullDetailsLink = document.getElementById('quickViewFullDetailsLink');
  const quickViewDrawer = document.getElementById('quickViewDrawer');

  let quickViewSizeChartModal = null;

  // Intercept sibling variant links inside Quick View (attach once).
  // Do NOT use `{ once: true }` because opening the size chart counts as a click
  // and would remove the handler, causing later sibling clicks to navigate to the PDP.
  if (altContainer && !altContainer.dataset.quickViewSiblingInterceptAttached) {
    altContainer.addEventListener('click', function (e) {
      const link = e.target.closest?.('a[href*="/products/"][class]');
      if (!link) return;

      const isSiblingVariant = link.classList.contains('product__sibling-variant');
      if (!isSiblingVariant && !link.href.includes('/products/')) return;

      e.preventDefault();
      e.stopPropagation();

      const productUrl = link.getAttribute('href');
      if (!productUrl) return;

      showSpinner();
      altContainer.innerHTML = "";
      setTimeout(() => {
        fetchProductData(productUrl, true);
      }, 0);
    });
    altContainer.dataset.quickViewSiblingInterceptAttached = 'true';
  }

  function moveSizeChartModalIntoQuickView() {
    if (!drawer || !quickViewDrawer) return;

    // The size chart DrawerModal is rendered inside the injected product HTML.
    // Move it under the quick view drawer so it behaves like part of the drawer UI.
    const modalsInAlt = altContainer
      ? Array.from(altContainer.querySelectorAll('#DrawerModal--size_chart'))
      : [];
    const modal =
      modalsInAlt[modalsInAlt.length - 1] ||
      quickViewDrawer.querySelector('#DrawerModal--size_chart') ||
      null;
    if (!modal) return;

    // Remove duplicates/stale content (there should only be one size chart modal).
    if (altContainer) {
      altContainer.querySelectorAll('#DrawerModal--size_chart').forEach((el) => {
        if (el !== modal) el.remove();
      });
    }
    quickViewDrawer.querySelectorAll('#DrawerModal--size_chart').forEach((el) => {
      if (el !== modal) el.remove();
    });

    // Ensure the modal is always a direct child of drawerContent, even if it is currently under another parent.
    if (modal.parentElement !== quickViewDrawer) quickViewDrawer.appendChild(modal);

    quickViewSizeChartModal = modal;
  }

  function cleanupQuickViewMovedModals() {
    if (quickViewSizeChartModal && quickViewSizeChartModal.parentNode) {
      quickViewSizeChartModal.parentNode.removeChild(quickViewSizeChartModal);
    } else if (quickViewDrawer) {
      quickViewDrawer.querySelector('#DrawerModal--size_chart')?.remove();
    }
    quickViewSizeChartModal = null;
  }

  function normalizeQuickViewHideSelectors(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map((s) => (typeof s === 'string' ? s.trim() : ''))
      .filter(Boolean)
      .map((s) => {
        // Allow passing either a class name or a full selector.
        if (s.startsWith('.') || s.startsWith('#') || s.startsWith('[') || s.includes(' ') || s.includes('>') || s.includes(':')) return s;
        return `.${s}`;
      });
  }

  function getQuickViewHideSelectors() {
    const fromArray = window.BauerThemeConfig?.quickView?.hideInProductSubWrapper;
    if (Array.isArray(fromArray)) return normalizeQuickViewHideSelectors(fromArray);

    const raw = window.BauerThemeConfig?.quickView?.hideInProductSubWrapperRaw;
    if (typeof raw !== 'string') return [];
    // Allow: newline-separated, comma-separated, or mixed
    const parts = raw
      .split(/\r?\n/)
      .flatMap((line) => line.split(','))
      .map((s) => s.trim())
      .filter(Boolean);

    return normalizeQuickViewHideSelectors(parts);
  }

  function applyQuickViewHidesWithinAltContainer(root) {
    if (!root) return;

    const selectors = getQuickViewHideSelectors();
    if (!selectors.length) return;

    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((el) => {
        el.style.display = 'none';
      });
    });
  }

  function applyQuickViewHidesWithRetry(root, remainingTries = 20) {
    // In Quick View, `add-to-cart-sticky.js` (where the global config lives) can be injected dynamically.
    // Retry briefly so the config has time to load before we apply the hides.
    const selectors = getQuickViewHideSelectors();
    if (selectors.length) {
      applyQuickViewHidesWithinAltContainer(root);
      return;
    }
    if (remainingTries <= 0) return;
    setTimeout(() => applyQuickViewHidesWithRetry(root, remainingTries - 1), 100);
  }

  function showSpinner() {
    spinner.classList.remove('hidden');
    setTimeout(() => {
      spinner.classList.add('show');
    }, 10);
  }

  function hideSpinner() {
    spinner.classList.remove('show');
    setTimeout(() => {
      spinner.classList.add('hidden');
    }, 300);
  }

  function openDrawer() {
    drawer.classList.remove('hidden');
    drawerOverlay.style.display = 'block';
    setTimeout(() => {
      drawer.classList.add('show');
    }, 10);
  }

  function closeDrawer() {
    drawer.classList.remove('show');
    setTimeout(() => {
      drawer.classList.add('hidden');
      cleanupQuickViewMovedModals();
      altContainer.innerHTML = ""; // Optional: clear content on close
      if (fullDetailsLink) {
        fullDetailsLink.style.display = 'none';
        fullDetailsLink.href = '#';
      }
    }, 300);
  }

  // Close on overlay click
  drawerOverlay.addEventListener('click', closeDrawer);

  // Close on close button
  drawerCloseBtn.addEventListener('click', closeDrawer);

  // You may want to add this too to allow ESC key to close the drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });
  window.addEventListener('quickViewClick', (e) => {
    const { productUrl, productName } = e.detail;
    // Perform any additional actions here
});
// Attach listener once DOM is ready
window.addEventListener('ssQuickViewClick', (e) => {
    const handle = e?.detail?.productUrl;
    if (!handle) return;

    fetchProductData(handle);
    openDrawer();
});

// For dynamically loaded content, use event delegation from the drawer
drawer.addEventListener('click', function(e) {
  const target = e.target;
  if (target && (target.classList.contains('product-form__submit') || 
     (target.closest('.product-form__submit') && 
      (target.closest('.product-form__submit').name === 'add' || 
       target.closest('.product-form__submit').textContent.trim().toLowerCase().includes('add'))))) {
    
    setTimeout(() => {
      closeDrawer();
    }, 1000);
  }

  if(target && target.classList.contains('product__media-toggle')) {
    // Toggle the class for modal behavior when media is clicked
    const modal = document.querySelector('#drawerContent');
    console.log(modal);
    console.log("drawerContent");
  }
});

// Your existing fetchProductData function
// Track ongoing fetches to prevent duplicates
const pendingFetches = new Map();
async function fetchProductData(handle, load = false) {
  // If there's already a fetch in progress for this handle, return the existing promise
  if (pendingFetches.has(handle)) {
    console.log(`🔄 Already fetching product data for: ${handle}`);
    return pendingFetches.get(handle);
  }

  console.log("🚨 Fetching product data for handle:", handle, "load:", load);
  const url = `${window.location.origin}${handle}`;
  showSpinner();

  // Update the "View Full Details" link with the product URL
  if (fullDetailsLink) {
    fullDetailsLink.href = handle;
    fullDetailsLink.style.display = 'block';
  }
  // Create a new promise for this fetch and store it
  const fetchPromise = (async () => {
    try {
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const productSection = doc.querySelector('.shopify-section.product-section.spaced-section');

      const loadedScripts = window._quickViewLoadedScripts || (window._quickViewLoadedScripts = new Set());
      if(!load) {
        productSection.querySelectorAll('script').forEach(script => {
          // Only append executable scripts (skip JSON-LD and other data scripts)
          if (script.type && script.type !== "text/javascript" && script.type !== "") {
            return;
          }
          let scriptId = script.src ? script.src : script.textContent.trim();
          if (loadedScripts.has(scriptId)) {
            console.log(`Script already loaded: ${scriptId}`);
            return; // Skip if already loaded
          }
          loadedScripts.add(scriptId);

          const newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src;
            newScript.async = script.async;
            newScript.defer = script.defer;
          } else {
            newScript.textContent = script.textContent;
          }
          
          document.body.appendChild(newScript);
        });
      }

      // Extract product variant count
      

      if(await !addInnerHTML(productSection, altContainer, url)) return;
      
      
      if (productSection) {
          productSection.querySelectorAll('.slider.slider--mobile').forEach(el => {
            el.classList.remove('slider--mobile');
            el.classList.add('slider--everywhere');
          });
        if (window.innerWidth >= 1024) {
          productSection.classList.add('force-mobile-style-on-quick-view');
        }
        // Re-initialize the slider after changing the class
        altContainer.innerHTML = productSection.outerHTML;

        // Ensure the size chart drawer modal lives under the quick view drawer
        moveSizeChartModalIntoQuickView();

        if(!load) {
         class ProductModal extends ModalDialog {
            constructor() {
              super();
            }

            hide() {
              super.hide();
            }

            show(opener) {
              super.show(opener);
              this.showActiveMedia();
            }

            showActiveMedia() {
              this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                  element.classList.remove('active');
                }
              );
              const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
              const activeMediaTemplate = activeMedia?.querySelector('template');
              const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
              if (!activeMedia) return;
              activeMedia.classList.add('active');
              activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });
              const container = this.querySelector('[role="document"]');
              if (!container) return;

              // Reset to top and left so first open behaves like second
              container.scrollTop = 0;
              container.scrollLeft = 0;

              requestAnimationFrame(() => {
                const scrollPosition = activeMedia.offsetLeft - (container.clientWidth / 2) + (activeMedia.offsetWidth / 2);
                container.scrollLeft = Math.max(0, scrollPosition);
              });

              // Load and autoplay videos when modal opens (mobile: both; desktop: external only)
              if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
                const hasExternalVideo = activeMediaContent && (activeMediaContent.querySelector('.js-youtube') || activeMediaContent.querySelector('.js-vimeo'));
                const hasRegularVideo = activeMediaContent?.querySelector('video');
                if (hasExternalVideo || hasRegularVideo) {
                  activeMedia.loadContent();
                  if (hasRegularVideo) {
                    const isMobile = window.innerWidth <= 749 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    const checkVideo = setInterval(() => {
                      const video = activeMedia.querySelector('video');
                      if (video) {
                        clearInterval(checkVideo);
                        if (isMobile) {
                          video.autoplay = true;
                          if (video.paused) video.play().catch(() => {});
                        } else {
                          video.autoplay = false;
                          if (!video.paused) video.pause();
                        }
                      }
                    }, 50);
                    setTimeout(() => clearInterval(checkVideo), 2000);
                  }
                }
              }
            }
          }

          if (!customElements.get('product-modal')) {
            customElements.define('product-modal', ProductModal);
          }
        }

        // Hide the product__sub-wrapper containing store locator in quick view
        const storeLocatorWrapper = altContainer.querySelector('.product__info-container .product__sub-wrapper .product__store_locator')?.closest('.product__sub-wrapper');
        if (storeLocatorWrapper) {
          storeLocatorWrapper.style.display = 'none';
        }

        // Hide configured elements inside `.product__sub-wrapper` (Quick View only)
        applyQuickViewHidesWithRetry(altContainer);

      } else {
        altContainer.innerHTML = "<p>Product section not found.</p>";
      }
    } catch (err) {
      hideSpinner();
      console.error("🚨 Error during fetchProductData:", err);
      altContainer.innerHTML = "<p>Product Not Found</p>";
    } finally {
      // Remove this handle from pending fetches when done
      pendingFetches.delete(handle);
    }
  })();

  // Store the promise for this handle
  pendingFetches.set(handle, fetchPromise);
  
  // Return the promise
  return fetchPromise;
}

async function addInnerHTML(productSection, altContainer, url) {
  const variantCount = productSection.querySelector('variant-selects, variant-radios')?.querySelectorAll('option, input[type="radio"]')?.length || 0;

  if(variantCount > 1) {
    altContainer.innerHTML = productSection.outerHTML;
    hideSpinner();
    return true;
  } else {
    altContainer.innerHTML = productSection.outerHTML;
    await addToCartSS(url);
    return false;
  }
}

async function addToCartSS(url) {
  const productUrl = new URL(url);
    const productResponse = await fetch(`${productUrl.origin}${productUrl.pathname}.js`);
    if (productResponse.ok) {
      const productData = await productResponse.json();
      // If product has only one variant and no options, add to cart directly
      if (productData.variants.length === 1 && 
          (!productData.options || productData.options.every(option => option.values.length <= 1))) {
        try {
            const quickViewProductForm = document.querySelector('product-form');
            if (quickViewProductForm && quickViewProductForm.onSubmitHandler) {
              quickViewProductForm.onSubmitHandler(new Event('submit'));
              hideSpinner();
              closeDrawer();
            }
        } catch (addError) {
          console.error("Error adding product to cart:", addError);
        }
      }
    } else {
      console.error("Error fetching product data:", productResponse.statusText);

    }
}
